<template>
    <div id="app">
        <router-view />
        <updateload ref="updateload" />
        <!-- <mywebviewnowin ref="mywebviewnowin"></mywebviewnowin> -->
    </div>
</template>
 
<script>
// 新增模块    
import IDB from '@/db/index.js';
import { installKefuNotifySoundUnlock } from "@/utils/kefuNotifySound";

export default {
    name: 'App',
    mounted() {
        window.$updateload = this.$refs.updateload;
        // window.$mywebviewnowin = this.$refs.mywebviewnowin;
        this.$store.dispatch('bindEvent/run');
        try {
            installKefuNotifySoundUnlock();
        } catch (e) {}
        // process.env.NODE_ENV == "development" && this.initDB()
    },
    methods: {
        async initDB() {
            await IDB.openDB();
            // 从 idb 里恢复 productState 表里的数据
            const savedState = await IDB.table('productState').where({ id: 1 }).get();

            if (savedState) {
                // 删除不需要赋值的字段
                delete savedState.id;
                this.$store.commit('product/RECOVER_STATE', { data: savedState, field: ['copyLinkValue', 'product', 'jumpProduct', 'selectShop', 'shopList','shangjiaproduct','shangjiselection'] });
            }
        }
    },
}
</script>

<style src="./assets/com.css"></style>

<style src="./assets/main.css"></style>
